export const OPEN = 'HELPWIDGET_OPEN';
export const CLOSE = 'HELPWIDGET_CLOSE';
export const RESET = 'HELPWIDGET_RESET';
export const SUPPORT_DESK_ACTIVE = 'SUPPORT_DESK_ACTIVE';
export const NEW_FEATURES_ACTIVE = 'NEW_FEATURES_ACTIVE';
export const RECEIVE_NEW_FEATURES = 'NEW_FEATURES_ACTIVE'; // TODO: is this a bug ?
export const LIVE_CHAT_ACTIVE = 'LIVE_CHAT_ACTIVE';
export const LIVE_CHAT_INACTIVE = 'LIVE_CHAT_INACTIVE';



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/helpwidget/helpwidget-constants.js